module.exports = __webpack_public_path__ + "static/media/unchecked-icon.02b9d68f.svg";